<template>
  <v-app>
    <app-header></app-header>
    <v-main>
      <v-stepper v-model="appCurrentStep" elevation="0" tile :alt-labels="$vuetify.breakpoint.mdAndUp" :vertical="!$vuetify.breakpoint.mdAndUp">
        <v-row class="justify-start justify-md-center mt-2">
          <v-col cols="12" sm="11">
            <v-stepper-header v-show="$vuetify.breakpoint.mdAndUp">
              <template >
                <v-stepper-step
                  v-for="s in steps" 
                  :key="`${s.id}-step`"                  
                  :complete="appCurrentStep > s.number"
                  :step="s.number"
                  color="rgb(0 48 87)"
                  class="py-1"
                >
                  {{s.name}}
                </v-stepper-step>        
              </template>
            </v-stepper-header>
          </v-col>
        </v-row>
        <v-container>
          <v-row>
            <v-col cols="12" class='text-center font-weight-light'><small><span class="required font-weight-regular red--text"> *</span> denotes a required field</small></v-col>
          </v-row>
          <v-stepper-step
            v-show="!$vuetify.breakpoint.mdAndUp"
            :key="`${steps[0].id}-step`"
            :complete="appCurrentStep > steps[0].number"
            :step="steps[0].number"
            color="rgb(0 48 87)"
            class="align-self-start"
          >
            {{steps[0].name}}
          </v-stepper-step> 
          <v-stepper-content step="1" class="p-0">
            <v-row class="justify-center">
              <v-col cols="12" md="10">
                <personal-info @next-step="appCurrentStep=2"></personal-info>
              </v-col>  
            </v-row>              
          </v-stepper-content>
          <v-stepper-step
            v-show="!$vuetify.breakpoint.mdAndUp"
            :key="`${steps[1].id}-step`"
            :complete="appCurrentStep > steps[1].number"
            :step="steps[1].number"
            color="rgb(0 48 87)"
            class="py-1"
          >
            {{steps[1].name}}
          </v-stepper-step>
          <v-stepper-content step="2">
            <v-row class="justify-center">
              <v-col cols="12" md="10">
                <work-info @next-step="appCurrentStep = 3;" @go-back="appCurrentStep = 1;"></work-info>              
              </v-col>  
            </v-row>            
          </v-stepper-content>
          <v-stepper-step
            v-show="!$vuetify.breakpoint.mdAndUp"
            :key="`${steps[2].id}-step`"
            :complete="appCurrentStep > steps[2].number"
            :step="steps[2].number"
            color="rgb(0 48 87)"
            class="py-1"
          >
            {{steps[2].name}}
          </v-stepper-step>
          <v-stepper-content step="3">
            <v-row class="justify-center">
              <v-col cols="12" md="10">
                <membership-info  @next-step="appCurrentStep = 4;" @go-back="appCurrentStep = 2;"></membership-info>             
              </v-col>  
            </v-row>
          </v-stepper-content>
          <v-stepper-step
            v-show="!$vuetify.breakpoint.mdAndUp"
            :key="`${steps[3].id}-step`"
            :complete="appCurrentStep > steps[3].number"
            :step="steps[3].number"
            color="rgb(0 48 87)"
            class="py-1"
          >
            {{steps[3].name}}
          </v-stepper-step>
          <v-stepper-content step="4">
            <v-row class="justify-center">
              <v-col cols="12" md="10">
                <pac-info @go-back="appCurrentStep = 3;" @next-step="appCurrentStep = 5;"></pac-info>          
              </v-col>  
            </v-row>            
          </v-stepper-content>
          <v-stepper-step
            v-show="!$vuetify.breakpoint.mdAndUp"
            :key="`${steps[4].id}-step`"
            :complete="appCurrentStep > steps[4].number"
            :step="steps[4].number"
            color="rgb(0 48 87)"
            class="py-1"
          >
            {{steps[4].name}}
          </v-stepper-step>
          <v-stepper-content step="5">
            <v-row class="justify-center">
              <v-col cols="12" md="10">
                <finish-step @go-back="appCurrentStep = 4;"></finish-step>          
              </v-col>  
            </v-row>            
          </v-stepper-content>
        </v-container>
      </v-stepper>            
    </v-main>
    <v-idle @idle="onidle" @remind="onremind" :events="['click', 'keypress']" :reminders="[30]" :duration="timeoutDuration" style='display:none;'/>
    <timeout-warning-dialog v-if="showTimeoutWarning" :timeTillTimeout="30" @close-dialog="showTimeoutWarning = false;"></timeout-warning-dialog>
  </v-app>
</template>

<script>
import axios from 'axios';
import AppHeader from './components/AppHeader.vue';
import FinishStep from './components/FinishStep.vue';
import MembershipInfo from './components/MembershipInfo.vue';
import PersonalInfo from './components/PersonalInfo.vue';
import WorkInfo from './components/WorkInfo.vue';
import PacInfo from './components/PacInfo.vue';
import TimeoutWarningDialog from './components/DialogComponents/TimeoutWarningDialog.vue';
import commonMixins from '@/mixins/commonMixins';

export default {
  components: { AppHeader, PersonalInfo, WorkInfo, MembershipInfo, FinishStep, PacInfo, TimeoutWarningDialog },
  name: 'App',
  mixins:[commonMixins],   
  data: () => ({
    appCurrentStep: 1,
    steps:[
      {
        id: 'personal_info',
        name: 'Personal Info',
        number: 1,
      },
      {
        id: 'work_info',
        name: 'Work Info',
        number: 2,
      },
      {
        id: 'membership_info',
        name: 'Membership Info',
        number: 3,
      },
      {
        id: 'pac_info',
        name: 'PAC Info',
        number: 4,
      },
      {
        id: 'finish',
        name: 'Finish',
        number: 5,
      },
    ],
    showTimeoutWarning: false,
    timeoutDuration: 900, //60s*15min = 900s
  }),
  methods:{    
    async onidle(){
      if(this.$store.state.is_initiated){
        await this.log_activity(`Users session timed out after ${this.timeoutDuration/60} minutes of inactivity`);
      }
      window.sessionStorage.clear();
      location.reload();
    },
    onremind(){
      this.showTimeoutWarning = true;      
    },
    log_activity(description, detail={}){
        return axios.post(`${this.$baseURL}/common/application/`, JSON.stringify({doCmd:'log_activity_from_client', app_id: window.sessionStorage.getItem('appID'),activityDesc: description, detail:detail}), {
            headers : {'Content-Type': 'application/json'}
        }); 
    }
  },
  beforeCreate: async function(){       
    if(this.$route.params.appID){
      //if there's an appID in the route, put it in session storage and then navigate to a clean url
      window.sessionStorage.setItem('appID', this.$route.params.appID);
      this.$router.push('/');
    }

    const app_id =  window.sessionStorage.getItem('appID');
    const appIDPayload = {doCmd: 'get_app_id'};
    if(app_id){ appIDPayload['app_id'] = app_id; }

    const get_app_id = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(appIDPayload), {
        headers : {'Content-Type': 'application/json'}
    });

    this.$store.state.is_initiated = false;
    const {data: { result }} = get_app_id;
    this.$store.state.survey_url = result.survey_url;
    if(result.is_existing){
      //result.what_step+1 because the value returned is the last step completed so show the next step they need to complete
      this.appCurrentStep = !result.what_step?1:result.what_step+1;      
      this.$store.state.is_initiated = result.is_existing;
      this.$store.state.has_tokenized_pmt = result.has_tokenized_pmt;
      Object.keys(result.details).forEach(k=>{this.$store.state[k] = result.details[k]});
    }
    
    window.sessionStorage.setItem('appID', result.app_id);
  },
  async mounted(){
    //once the page is loaded lets get the terms and conditions info
    const tnc_payload = {doCmd: 'get_terms_and_conditions'};
    const tnc = await axios.post(`${this.$baseURL}/common/application/`, JSON.stringify(tnc_payload), {
      headers: {'Content-Type':'application/json'}
    });
    const {data: { error:tnc_error, errortext:tnc_errortext, result: tnc_result } } = tnc;
    if(tnc_error > 0){
      this.showError = true;
      this.errorObj = {error:tnc_error, errortext:tnc_errortext};
      this.errorIsFatal=false;
      return;
    }
    this.$store.state.termsAndConditions = tnc_result;
  }

};
</script>

<style scoped>
.v-stepper__header{
  box-shadow:0px 0px 0px 0px rgb(0 0 0 / 0%), 0px 0px 0px 0px rgb(0 0 0 / 0%), 0px 0px 0px 0px rgb(0 0 0 / 0%);
}
.v-stepper__content{
  margin-left:12px !important;
  padding-left: 4px;
  padding-right: 12px;
}
.v-stepper__step{
  padding-left:0px!important;
}
</style>

<style>
  .required{
    font-size:0.80em; 
  }
</style>